import React, {Component} from 'react';
import cookie from "react-cookies";
import {Stack, Typography} from "@mui/material";
import {error_manager} from "../../../helper/error_manager";
import {HorizontalDivider} from "../components/components";
import {StyledInputBase} from "../components/StyledComponents";
import {aclPermissions, hasPermissions} from 'const/ACLPermissions';
import {get_response, post_response} from "../../../helper/request";
import {askAnnotationAi, looksLikeAiTrigger, stripAiTrigger} from "../utils/slide_ai_utils";

class AnnotationComments extends Component {
    constructor(props) {
        super(props);
        this.state = {
            comments: [],
            submitting: false,
            value: '',
            data: null,
            username: cookie.loadAll().username,
            userId: cookie.loadAll().user_id,
        }
    }

    componentDidMount() {
        this.getComment(this.props.annoId);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.annoId !== this.props.annoId) {
            this.getComment(this.props.annoId);
        }
    }

    createCommentPermission = hasPermissions([aclPermissions.create_annotation_comment])
    annotationAiPermission = hasPermissions([aclPermissions.annotation_ai])

    getComment(value) {
        if (value !== null) {
            let url = `/api/comments/?annotation=${value}`
            get_response(url)
                .then(response => {
                    if (response.status === 201 || response.status === 200 || response.status === 301 || response.status === 302) {
                        this.extractComment(response.data);
                    }
                })
                .catch(err => {
                    if (err?.response?.status === 403) {

                    } else if (err?.response?.status === 401 || err?.response?.status === 400) {
                        error_manager('Fetching comments Failed');
                    }
                });
        }
    }

    handleSubmit = () => {
        if (!this.state.value) {
            return;
        }
        const raw = this.state.value;
        if (looksLikeAiTrigger(raw) && this.annotationAiPermission) {
            this.submitAiAsk(raw);
            return;
        }
        if (looksLikeAiTrigger(raw) && !this.annotationAiPermission) {
            error_manager('No permission to use @ai');
            return;
        }

        this.setState({submitting: true});
        let val = {"author": this.state.username, "content": raw};
        this.sendComment(val);
        this.setState({
            submitting: false,
            value: '',
            comments: [
                ...this.state.comments,
                {author: this.state.username, content: raw},
            ],
        });
    }

    submitAiAsk = (raw) => {
        const question = stripAiTrigger(raw);
        if (!question) {
            error_manager('@ai requires a question');
            return;
        }
        this.setState({
            submitting: true,
            value: '',
            comments: [
                ...this.state.comments,
                {author: this.state.username, content: raw},
            ],
        });
        askAnnotationAi({
            annotationId: this.props.annoId,
            question,
            rawComment: raw,
        })
            .then(() => {
                this.setState({submitting: false});
                this.getComment(this.props.annoId);
            })
            .catch((err) => {
                this.setState({submitting: false});
                error_manager("AI ask failed", err);
                this.getComment(this.props.annoId);
            });
    }

    extractComment = (data) => {
        var com = [];
        data.reverse().map(index => {
            try {
                let par = JSON.parse(index.comment);
                com.push(par);
            } catch (e) {
                com.push({author: "?", content: String(index.comment)});
            }
            return index;
        });
        this.setState({
            comments: com
        });
        this.updateScroll();
    }

    updateScroll() {
        let element = document.getElementById("messageBody");
        if (element)
            element.scrollTop = element.scrollHeight;
    }

    handleChange = (e) => {
        this.setState({
            value: e.target.value,
        });
    }

    sendComment(value) {
        let val = {"user": this.state.userId, "comment": JSON.stringify(value), "annotation": this.props.annoId};
        let url = `/api/comments/`;
        post_response(url, val)
            .then(response => {
                if (response.status === 201 || response.status === 200 || response.status === 301 || response.status === 302) {
                    this.updateScroll();
                } else if (response.status === 403 || response.status === 401 || response.status === 400)
                    error_manager('Failed to add comments');
            })
            .catch(err => error_manager("Failed to add comments", err));
    }

    getComments = () =>
        <Stack direction={"column"} spacing={0.5} maxHeight={200} overflow={"auto"} id="messageBody">
            {this.state.comments.map((comment, index) => (
                <div key={index}>
                    <HorizontalDivider sx={{my: 0.5, opacity: 0.4}}/>
                    <Typography variant="body1" sx={{fontWeight: "bold"}}>{comment.author}</Typography>
                    <Typography variant="body2" sx={{whiteSpace: "pre-wrap"}}>{comment.content}</Typography>
                </div>
            ))}
        </Stack>

    getInput = () =>
        <Stack spacing={0.5}>
            {this.annotationAiPermission &&
                <Typography variant="caption" sx={{opacity: 0.75}}>
                    Tip: @ai ask about this region (research only; not a diagnosis)
                </Typography>}
            <StyledInputBase
                size={'small'}
                placeholder={this.annotationAiPermission ? "Type Comment or @ai …" : "Type Comment..."}
                onChange={this.handleChange}
                disabled={this.state.submitting || !this.createCommentPermission}
                value={this.state.value}
                onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                        this.handleSubmit();
                        e.preventDefault();
                    }
                }}
            />
        </Stack>

    render() {
        return <Stack direction={"column"}>
            {this.state.comments?.length > 0 && <Typography variant={"overline"} align={"left"} sx={{fontSize: "0.9vw", fontWeight: "bold"}}>
                Comments
            </Typography>}
            {this.getComments()}
            {this.getInput()}
        </Stack>
    }
}

export default AnnotationComments;
